<template>
    <div class="location-map overflow-hidden">
        <google-maps-find-location :address="addressForMap" :initialPos="initialPos" :selectable="false"></google-maps-find-location>
    </div>
</template>

<script>
import GoogleMapsFindLocation from '@/components/GoogleMapsFindLocation.vue'
export default {
    components:{
        GoogleMapsFindLocation
    },
    props:{
        value:Object
    },
    computed:{
        initialPos(){
            if(this.value.Xcoordinate && this.value.Ycoordinate){
                return {lat:Number(this.value.Xcoordinate),lng:Number(this.value.Ycoordinate)}
            }else return null
        },
        addressForMap(){
            return [
                this.value.Country || null,
                this.value.Province || null,
                this.value.District || null,
                this.value.Neighborhood || null
            ].join(',')
        },
    }
}
</script>

<style>
.location-map{
    height: 450px;
}
</style>